import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import Can from "../rbac/can";
import UserUtils from "../utils/UserUtils";
import imgHome from '../../img/menu/icone-home.svg';
import imgHomeHover from '../../img/menu/icone-home-hover.svg';
import imgFolder from '../../img/menu/icone-folder.svg';
import imgFolderHover from '../../img/menu/icone-folder-hover.svg';
import imgSearch from '../../img/menu/icone-recherche.svg';
import imgSearchHover from '../../img/menu/icone-recherche-hover.svg';
import imgMail from '../../img/menu/icone-mail.svg';
import imgMailHover from '../../img/menu/icone-mail-hover.svg';
import imgBuild from '../../img/menu/icone-build.svg';
import imgBuildHover from '../../img/menu/icone-build-hover.svg';
import imgLock from '../../img/menu/icone-cadenas.svg';

const mapStateToProps = (state) => {
  return {
    searchData: state.reduceFilters.searchData,
    menuActive: state.reduceMenu.menuActive
  }
}

export default connect(mapStateToProps)(MenuDrawer);

function MenuDrawer(props) {

  let history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(props.open);
  const [menuFat] = useState(UserUtils.menusAuthorized() < 3)
  const { t } = useTranslation('common');
  const [activeButton, setActiveButton] = useState('home');

  useEffect(() => {
    const imageList = [imgHome, imgHomeHover, imgFolder, imgFolderHover, imgSearch, imgSearchHover, imgMail, imgMailHover, imgBuild, imgBuildHover, imgLock];
    imageList.forEach((image) => {
      new Image().src = image
    });
  });


  // Gestion de l'ouverture/fermeture du Drawer
  useEffect(() => { setOpen(props.open) }, [props.open]);

  // Rafraichit le menu actif si changement de destination dans un autre écran
  useEffect(() => {
    if (props.menuActive !== activeButton) {
      setActiveButton(props.menuActive);
    }
  }, [props.menuActive]);

  const handleDrawerClose = () => {
    props.onDrawpen(false);
  };

  const handleDestination = destination => {
    history.push(destination);
  }

  const MenuOption = (menuOptionProps) => {
    return (
      <Link to={"/" + menuOptionProps.link} className="clearLink">
        <button className={clsx({ "urgent": menuOptionProps.urgent, "menuFatBtn": open && menuFat, "menuBtn": !menuFat || !open, "active": activeButton === menuOptionProps.link })}>
          <div className={clsx(menuOptionProps.iconOption, { "menuFatIcon": open && menuFat, "menuIcon": !menuFat || !open })} />
          <span className={clsx({ "menuFatText": open && menuFat })}>{menuOptionProps.textOption}</span>
        </button>
      </Link>)
  }

  return (
    <div className="drawContainer">
      <Drawer variant="permanent"
        className={clsx("drawer",
          {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
        classes={{
          paper: clsx("noborder", {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >

        <div className={classes.toolbar}>
          <Link to="/" className="clearLink"><div className="menuLogo" /></Link>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ?
              <ChevronRightIcon /> :
              <ChevronLeftIcon />}
          </IconButton>
        </div>

        <Link to="/" className="clearLink">
          <button className={clsx({ "menuFatBtn": open && menuFat, "menuBtn": !menuFat || !open, "active": activeButton === "home" })}>
            <div className={clsx("iconHome", { "menuFatIcon": open && menuFat, "menuIcon": !menuFat || !open })} />
            <span className={clsx({ "menuFatText": open && menuFat })}>{t('MEN_OPT_001')}</span>
          </button>
        </Link>

        <Can
          perform="console-cases:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_002')} iconOption="iconFolder" link="console-cases" />
          )}
        />
        <Can
          perform="guarantee:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_010')} iconOption="iconCar" link="console-guarantees" />
          )}
        />
        <Can
          perform="console-repairs:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_009')} iconOption="iconBuild" link="console-repairs" />
          )}
        />
        <Can
          perform="console-messages:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_003')} iconOption="iconMail" link="console-messages" />
          )}
        />
        <Can
          perform="search-cases:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_004')} iconOption="iconSearch" link="search-cases" />
          )}
        />

        <Can
          perform="console-tasks:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_008')} iconOption="iconTache" link="console-tasks" />
          )}
        />

        <Can
          perform="search-user:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_007')} iconOption="iconCollab" link="search-user" />
          )}
        />

        <Can
          perform="reporting:visit"
          yes={() => (
            <MenuOption textOption={t('MEN_OPT_006')} iconOption="iconReporting" link="console-reporting" />
          )}
        />

        <MenuOption textOption={t('FAQ')} iconOption="iconFaq" link="faq" />

        <div className="grow" />

        <button className={open ? 'btnNousContacter' : 'hide'} onClick={() => props.dispatch({ type: "SHOW_CONTACT" })}>{t('MEN_CNT_001')}</button>

        <div className={open ? 'legalLinks' : 'hide'}>
          <button className="menuLink" onClick={() => handleDestination('/legal-agreements')} >{t('MEN_LEG_001')}</button>
        </div>
      </Drawer>
    </div>
  );
}



const drawerWidth = 240;

const useStyles = makeStyles(theme => ({

  drawerOpen: {
    width: drawerWidth,
    overflow: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    border: 'none',

  },
  drawerClose: {
    overflow: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 1,
    },
    border: 'none',
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    marginBottom: '60px',
    ...theme.mixins.toolbar,
  },

}));

